<div class="accordion" id="accordionUserPoints">
  <button
    *ngIf="hasPoints"
    data-bs-toggle="collapse"
    data-bs-target="#collapseUserPoints"
    aria-expanded="false"
    aria-controls="collapseUserPoints"
    type="button"
    class="sidebar__checkout-extra-item sidebar__summary-discount collapsed"
  >
    {{ 'sharedModule.bkgSummaryDiscounts.wantUsePoints' | translate }}
  </button>
  <div
    *ngIf="hasPoints"
    id="collapseUserPoints"
    class="accordion-collapse collapse"
    data-bs-parent="#accordionUserPoints"
  >
    <div *ngIf="!pointsApplied" class="accordion-body">
      <span class="sidebar__summary-points">
        {{ 'sharedModule.bkgSummaryDiscounts.availablePoints' | translate }}
        {{ userPoints }}
      </span>
      <span class="sidebar__summary-points"
        >{{ 'sharedModule.bkgSummaryDiscounts.discount' | translate }}
        {{ userPoints }}{{ 'common.euro' | translate }}</span
      >
      <button
        *ngIf="canUsePoints && !isLoadingCode"
        (click)="onClickRedeem()"
        type="button"
        class="btn-primary sidebar__summary-points-button"
      >
        {{ 'sharedModule.bkgSummaryDiscounts.redeem' | translate }}
      </button>
      <!-- TODO: change for better gif -->
      <div *ngIf="isLoadingCode" class="blue-spinner__small"></div>

      <!--  <img
        *ngIf="isLoadingCode"
        class="sidebar__summary-points-button"
        src="assets/images/spinners/spinner-XS-azul.gif"
      />-->
    </div>
    <div
      *ngIf="pointsApplied"
      class="accordion-body sidebar__summary-applied-body"
    >
      <span class="sidebar__summary-applied">
        {{
          'sharedModule.bkgSummaryDiscounts.pointsApplied'
            | translate: { points: appliedPoints }
        }}
      </span>
    </div>
  </div>
</div>
<div class="accordion" id="accordionPromoCode">
  <button
    data-bs-toggle="collapse"
    data-bs-target="#collapsePromoCode"
    aria-expanded="false"
    aria-controls="collapsePromoCode"
    type="button"
    class="sidebar__checkout-extra-item sidebar__summary-discount collapsed"
  >
    {{ 'sharedModule.bkgSummaryDiscounts.havePromoCode' | translate }}
  </button>
  <div
    id="collapsePromoCode"
    class="accordion-collapse collapse"
    data-bs-parent="#accordionPromoCode"
  >
    <div *ngIf="!promoSuccess" class="accordion-body">
      <input
        [(ngModel)]="promoCode"
        type="text"
        placeholder="{{
          'sharedModule.bkgSummaryDiscounts.insertCode' | translate
        }}"
        class="sidebar__summary-promo-code"
      />
      <button
        *ngIf="!isLoadingPromo"
        [disabled]="!promoCode"
        (click)="onClickValidatePromoCode()"
        type="button"
        class="btn-primary sidebar__summary-promo-code-button"
      >
        {{ 'sharedModule.bkgSummaryDiscounts.validate' | translate }}
      </button>
      <!-- TODO: change for better gif -->
      <div *ngIf="isLoadingPromo" class="blue-spinner__small"></div>

      <!--
      <img
        *ngIf="isLoadingPromo"
        class="sidebar__summary-promo-code-button"
        src="assets/images/spinners/spinner-XS-azul.gif"
      />-->
    </div>
    <div
      *ngIf="promoSuccess"
      class="accordion-body sidebar__summary-promo-success-body"
    >
      <span class="sidebar__summary-promo-success">
        {{ 'sharedModule.bkgSummaryDiscounts.promoSuccess' | translate }}
      </span>
    </div>
    <div
      *ngIf="promoFailed"
      class="accordion-body sidebar__summary-promo-fail-body"
    >
      <div>
        <button
          class="sidebar__summary-promo-fail__close"
          (click)="onCloseFailPromo()"
        >
          <img [src]="'assets/images/icons/close.svg'" />
        </button>
      </div>
      <span class="sidebar__summary-promo-fail">
        {{
          this.offerData?.offer?.promos[0]?.error
            ? this.offerData?.offer?.promos[0]?.error
            : ('sharedModule.bkgSummaryDiscounts.promoFailed' | translate)
        }}
      </span>
    </div>
  </div>
</div>
